import { getFragment } from '../graphql/client/helpers/get-fragment';
import type {
    DigitallyReceivedPrescriberOrderInfoFragment,
    UnclaimedPrescriberOrderInfoFragment,
} from '../graphql/generated/graphql';

export const useOrderProviders = (
    order:
        | DigitallyReceivedPrescriberOrderInfoFragment
        | UnclaimedPrescriberOrderInfoFragment
) => {
    if (order.__typename === 'DigitallyReceivedPrescriberOrder') {
        const providers = getFragment(order.preferredProvidersConnection);

        return providers?.edges.map((edge) => getFragment(edge.node)) ?? [];
    }

    return [];
};
